import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
  ADD_NEW_EVENT,
  DELETE_EVENT,
  GET_CATEGORIES,
  GET_EVENTS,
  UPDATE_EVENT,
} from "./actionTypes"
import {
  getEventsSuccess,
  getEventsFail,
  addEventFail,
  addEventSuccess,
  updateEventSuccess,
  updateEventFail,
  deleteEventSuccess,
  deleteEventFail,
  getCategoriesSuccess,
  getCategoriesFail,
} from "./actions"

//Include Both Helper File with needed methods
import {
  getEvents,
  addNewEvent,
  updateEvent,
  deleteEvent,
  getCategories,
} from "../../helpers/fakebackend_helper"

function* fetchEvents() {
  try {
    const response = yield call(getEvents)
    const activitySchedules = response.activity_schedules.map(schedule => ({
      id: schedule.id,
      title: schedule.title,
      start: schedule.start,
      end: schedule.end,
      classNames: schedule.classNames,
      category: schedule.category,
      description: schedule.description,
    }));
    yield put(getEventsSuccess(activitySchedules))
  } catch (error) {
    yield put(getEventsFail(error))
  }
}

function* onAddNewEvent({ payload: event }) {
  try {
    const categories = [
      { id: 1, title: "Completed", type: "bg-success" },
      { id: 2, title: "General", type: "bg-primary" },
      { id: 3, title: "Missed", type: "bg-danger" },
      { id: 4, title: "Urgent", type: "bg-warning" },
    ];
    const transformedEvent = {
      name: event.title,  
      description: event.description, 
      start_at: event.start, 
      end_at: event.end,  
      category: categories.find(cat => cat.type === event.category)?.title || 'General', 
    };
    const response = yield call(addNewEvent, transformedEvent)
    yield put(addEventSuccess(response))
  } catch (error) {
    yield put(addEventFail(error))
  }
}

function* onUpdateEvent({ payload: event }) {
  try {
    const categories = [
      { id: 1, title: "Completed", type: "bg-success" },
      { id: 2, title: "General", type: "bg-primary" },
      { id: 3, title: "Missed", type: "bg-danger" },
      { id: 4, title: "Urgent", type: "bg-warning" },
    ];

    const transformedEvent = {
      id: event.id,
      name: event.title,  
      description: event.description, 
      start_at: event.start, 
      end_at: event.end,  
      category: categories.find(cat => cat.type === event.category)?.title || 'General', 
    };
    const response = yield call(updateEvent, transformedEvent)
    yield put(updateEventSuccess(response))
  } catch (error) {
    yield put(updateEventFail(error))
  }
}

function* onDeleteEvent({ payload: event }) {
  try {
    const response = yield call(deleteEvent, event)
    yield put(deleteEventSuccess(response))
  } catch (error) {
    yield put(deleteEventFail(error))
  }
}

function* onGetCategories() {
  const categories = [
    { id: 1, title: "Completed", type: "bg-success" },
    { id: 2, title: "General", type: "bg-primary" },
    { id: 3, title: "Missed", type: "bg-danger" },
    { id: 4, title: "Urgent", type: "bg-warning" },
  ];
  try {
    // Directly yield success with static categories
    yield put(getCategoriesSuccess(categories))
  } catch (error) {
    yield put(getCategoriesFail(error))
  }
}

function* calendarSaga() {
  yield takeEvery(GET_EVENTS, fetchEvents)
  yield takeEvery(ADD_NEW_EVENT, onAddNewEvent)
  yield takeEvery(UPDATE_EVENT, onUpdateEvent)  
  yield takeEvery(DELETE_EVENT, onDeleteEvent)
  yield takeEvery(GET_CATEGORIES, onGetCategories)
}

export default calendarSaga
